import React from 'react'
import { makeStyles, Button, tokens, shorthands } from '@fluentui/react-components'
import { Dismiss24Regular } from '@fluentui/react-icons'
import { t } from '../../i18n/i18n'
import { Title } from '../common/text/Title'

const useStyles = makeStyles({
   backdrop: {
      top: 0,
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   customDialog: {
      border: 'none',
      backgroundColor: tokens.colorNeutralBackground1,
      borderRadius: tokens.borderRadiusXLarge,
      boxShadow: tokens.shadow64,
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxWidth: '90vw',
      height: '80dvh',
      '&::before': {
         content: '""',
         position: 'absolute',
         top: 0,
         left: 0,
         right: 0,
         height: '100px',
         backgroundColor: tokens.colorBrandBackground,
         borderTopLeftRadius: tokens.borderRadiusLarge,
         borderTopRightRadius: tokens.borderRadiusXLarge,
      },
      '@media (max-width: 600px)': {
         width: '100vw',
         minWidth: '100vw',
      },
   },
   flexContainer: {
      marginBottom: '20px',
      display: 'flex',
   },
   dialogTitle: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: tokens.colorBrandBackgroundInverted,
      ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalXXL),
      zIndex: 1,
   },
   closeButton: {
      color: tokens.colorBrandBackgroundInverted,
   },
   dialogContent: {
      ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalXXL),
      height: '100%',
      overflowY: 'hidden',
   },
})

type ModalSettingsProps = {
   open: boolean
   closeModal: () => void
   title: string
   children: JSX.Element | JSX.Element[]
}

export const ModalSettings = ({ open, closeModal, title, children }: ModalSettingsProps) => {
   const classes = useStyles()

   if (!open) return null

   return (
      <>
         <article className={classes.backdrop}>
            <div className={classes.customDialog} onClick={(e) => e.stopPropagation()}>
               <div className={classes.flexContainer}>
                  <div className={classes.dialogTitle}>
                     <Title weight="semibold" as="h1">
                        {title}
                     </Title>
                     <Button
                        aria-label={t('Close')}
                        onClick={closeModal}
                        icon={<Dismiss24Regular />}
                        appearance="transparent"
                        className={classes.closeButton}
                     />
                  </div>
               </div>
               <div className={classes.dialogContent}>{children}</div>
            </div>
         </article>
      </>
   )
}
